import { render, staticRenderFns } from "./Changefiles.vue?vue&type=template&id=46779a82&scoped=true"
import script from "./Changefiles.vue?vue&type=script&lang=js"
export * from "./Changefiles.vue?vue&type=script&lang=js"
import style0 from "./Changefiles.vue?vue&type=style&index=0&id=46779a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46779a82",
  null
  
)

export default component.exports